import { useLayoutEffect, useRef, useState } from 'react';
import { close } from 'ionicons/icons';

import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonModal, IonToolbar } from '@ionic/react';

import './ts-modal-drawer-common.scss';

import type { TSModalProps } from './TSModal';

// Make heightPercentage required
export interface TSDrawerProps extends TSModalProps {
  heightPercentage: number;
}

export const TSDrawer = ({
  className = '',
  heightPercentage,
  footerBorder = true,
  isOpen,
  handleXClick,
  titleContent,
  mainContent,
  footerContent,
  ...props
}: TSDrawerProps) => {
  const combinedClassNames = `ts-drawer ${className}`;
  const modalRef = useRef<HTMLIonModalElement>(null);
  const headerRef = useRef<HTMLIonHeaderElement>(null);
  const footerRef = useRef<HTMLIonFooterElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    const modalHeight = modalRef.current?.clientHeight ?? 0;
    const headerHeight = headerRef.current?.clientHeight ?? 0;
    const footerHeight = footerRef.current?.clientHeight ?? 0;
    setContentHeight(modalHeight - headerHeight - footerHeight);
  }, [isOpen, titleContent, handleXClick, footerContent]);

  return (
    <IonModal
      ref={modalRef}
      isOpen={isOpen}
      className={combinedClassNames}
      handle={false}
      initialBreakpoint={1}
      breakpoints={[0, 1]}
      style={{ ...props.style, '--height': `${heightPercentage}%` }}
      {...props}
    >
      <>
        {(titleContent || handleXClick) && (
          <IonHeader ref={headerRef} className="ion-no-border">
            <IonToolbar>
              {titleContent && <div className="title-content">{titleContent}</div>}
              {handleXClick && (
                <IonButtons slot="end">
                  <IonButton onClick={handleXClick}>
                    <IonIcon icon={close} />
                  </IonButton>
                </IonButtons>
              )}
            </IonToolbar>
          </IonHeader>
        )}
        <IonContent style={{ height: contentHeight }} className="ts-drawer-padding">
          {mainContent}
        </IonContent>
        {footerContent && (
          <IonFooter ref={footerRef} className={`${footerBorder ? '' : 'ion-no-border no-footer-border'}`}>
            <IonToolbar>{footerContent}</IonToolbar>
          </IonFooter>
        )}
      </>
    </IonModal>
  );
};
